import { action, atom } from '@reatom/framework'

import { AsyncStateN, pipe, Result } from '@blade/std-lib'
import { Network, selectedNetworkAtom } from '@root/entities/network'
import { ApiError, apiRequest } from '@root/shared/api'
import { tradeApiClientAtom } from '@root/shared/api/trade-api-client-atom'

import { SuggestedGasSettings } from '../model'

import type { Error } from '@root/shared'

export const fetchInfuraSuggestedSettingsRequestAction = action(
  async (ctx, network: Network.Network) => {
    const { tradeApiClient } = ctx.get(tradeApiClientAtom)

    const result = await ctx.schedule(() =>
      apiRequest(
        ctx,
        tradeApiClient.services.servicesGasNetworkCongestionList,
        [
          {
            network: Network.toDto(network),
          },
        ],
      ),
    )

    const mappedResult = pipe(
      result,
      Result.map(SuggestedGasSettings.fromDto),
      Result.mapError(ApiError.fallbackToUnknown),
    )
    return mappedResult
  },
  'fetchInfuraSuggestedSettingsRequestAction',
)

export const suggestedGasSettingsReatom = () => {
  const suggestedSettingsStateAtom = atom(
    AsyncStateN.notInitiated<Error.UnknownError, SuggestedGasSettings.Info>(),
    'suggestedSettingsStateAtom',
  )

  const loadSuggestedSettingsAction = action(async (ctx) => {
    suggestedSettingsStateAtom(ctx, AsyncStateN.loading())
    const network = ctx.get(selectedNetworkAtom)

    const result = await ctx.schedule(() =>
      fetchInfuraSuggestedSettingsRequestAction(ctx, network),
    )

    suggestedSettingsStateAtom(ctx, AsyncStateN.fromResult(result))
  }, 'loadSuggestedSettingsAction')

  return {
    loadSuggestedSettingsAction,
    suggestedSettingsStateAtom,
  }
}
